import type { Maybe } from "../types/Maybe"

export async function SafePromise<T>(promise: Promise<T>): Promise<Maybe<T>> {
  return Promise.resolve(promise)
    .then(value => ({
      value,
      error: undefined,
    }))
    .catch(err => {
      const error = err instanceof Error ? err : new Error(String(err))
      return {
        value: undefined,
        error,
      }
    })
}
